// Numeric ids our own games report to the `hits` table.
//
// The embedded games in games.json already use ids 656-746, so our own games
// take low numbers that can never collide with them. The backend casts
// game_id with Number(), so these have to stay numeric.
//
// Keep in sync with backend/api/data/ownGames.js, which maps the same ids back
// to names for the /stats endpoint.
const OWN_GAMES = {
  KRISKROS: 1,
  SLOVNIFOTBAL: 2,
  DOBYVATEL: 3,
  TANKY: 4,
};

export default OWN_GAMES;
